import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="template-treatment-plan"
export default class extends Controller {
  static targets = ["notes", "templateSelect"]

  connect() {
    console.log("Treatment plan controller connected")

    document.addEventListener('trix-initialize', this.trixInitialized.bind(this))
  }

  trixInitialized(event) {
    if (this.notesTarget.contains(event.target)) {
      this.trixEditor = event.target
    }
  }

  loadTemplate() {
    const templateId = this.templateSelectTarget.value
    if (templateId === "") return

    fetch(`/student/templates/${templateId}/content`)
      .then(response => response.json())
      .then(data => {
        if (this.trixEditor && this.trixEditor.editor) {
          this.trixEditor.editor.loadHTML(data.content)
        } else {
          const trixEditor = this.notesTarget.querySelector("trix-editor")
          if (trixEditor && trixEditor.editor) {
            trixEditor.editor.loadHTML(data.content)
          } else {
            console.error("Editor Trix no inicializado todavía")
          }
        }
      })
      .catch(error => console.error("Error al cargar la plantilla:", error))
  }
}
